import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const SponsorStrip = () => {
  const { t } = useI18n();
  const [sponsors, setSponsors] = useState([]);
  useEffect(() => { api.get("/sponsors").then(r => setSponsors(r.data)); }, []);
  if (!sponsors.length) return null;
  return (
    <section className="border-y border-[color:var(--border)] bg-[color:var(--bg-elev)] py-8">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center text-xs uppercase tracking-[0.3em] text-[color:var(--text-muted)] mb-6">
          {t("sponsors.eyebrow")}
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6" data-testid="sponsor-strip">
          {sponsors.map(s => {
            const img = (
              <img
                src={s.logo_url}
                alt={s.name}
                className="h-14 md:h-16 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity filter grayscale hover:grayscale-0"
                data-testid={`sponsor-logo-${s.id}`}
              />
            );
            return s.website ? (
              <a key={s.id} href={s.website} target="_blank" rel="noopener noreferrer" title={s.name}>{img}</a>
            ) : (
              <span key={s.id} title={s.name}>{img}</span>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const NewsletterForm = () => {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/subscribers", { email: email.trim(), source: "footer" });
      toast.success(t("newsletter.success"));
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("newsletter.fail"));
    } finally {
      setLoading(false);
    }
  };
  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md mx-auto" data-testid="newsletter-form">
      <div className="flex-1 relative">
        <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-muted)]" />
        <input
          data-testid="newsletter-email"
          type="email"
          required
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder={t("newsletter.placeholder")}
          className="w-full bg-[color:var(--bg-elev)] border border-[color:var(--border)] rounded-full pl-10 pr-4 py-2.5 text-sm focus:outline-none focus:border-[color:var(--accent)] transition-colors"
        />
      </div>
      <button
        data-testid="newsletter-submit"
        disabled={loading}
        className="bg-[color:var(--accent)] hover:brightness-110 disabled:opacity-50 text-black font-semibold px-6 py-2.5 rounded-full text-xs uppercase tracking-widest transition"
      >
        {loading ? "..." : t("newsletter.submit")}
      </button>
    </form>
  );
};
